export const services = [
    { key: "aa5f096a-9409-11ed-a1eb-0242ac121421", value: "1", label: "اعزام کارشناس", id: "1332" },
    { key: "aa5f0c30-9409-11ed-a1eb-0242ac121422", value: "2", label: "قطعات", id: "1330" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121423", value: "3", label: "راه اندازی", id: "2702" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121424", value: "4", label: "مشاوره", id: "1331" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "5", label: "اورهال", id: "1557" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "6", label: "عقد قرارداد سرویس دوره ای", id: "2761" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "7", label: "تعمیرات", id: "2762" },
    { key: "aa5f0d7a-9409-11ed-a1eb-0242ac121425", value: "9", label: "سایر", id: "2763" },
];

export function getServices() {
    return services.filter((g) => g);
}

export function getServicesById(id) {
    if (id === "none")
        return services;
    return services.filter(m => m.id === id);
}